import React from "react";
import Label from "../../../../../components/Modules/Label";
import { SingleChoiceProps } from "../../types/SurveyTypes";
import SingleChoice from "../../../../../components/Modules/SingleChoice";
import { LabelModule2 } from "../../../../../components/Modules/LabelModule2";

const SingleChoiceOne: React.FC<SingleChoiceProps> = ({
  options,
  question,
  required,
  actionId,
  answer,
  handleRadioChange,
  themeManager,
  singleChoiceModal,
}) => {
  const getCheckedValue = () => {
    if (singleChoiceModal === "modal3") {
      // console.log("answer", answer[actionId]);
      const checkedValue = answer[actionId] || ""; 
      return checkedValue;
    } else {
      const checkedValue = answer[actionId]?.[0] || ""; 
      return checkedValue;
    }
  };

  return (
    <div>
      <LabelModule2
        className="q-onb-singleChoiceOne-lebel"
        children={`${question}${required ? "*" : ""}`}
        style={themeManager.getLabelStyles()}
      />
      <div style={{ width: singleChoiceModal === "modal2" ? "91%" : "100%" }}>
        <SingleChoice
          options={options}
          type={singleChoiceModal}
          checked={getCheckedValue()} 
          onChange={(e: any) =>
            singleChoiceModal === "modal3"
              ? handleRadioChange(e.value, actionId, "")
              : handleRadioChange(e.target.value, actionId, "radio")
          }
          style={themeManager.getSingleChoiceStyles()}
          hoverBackground={themeManager.getSingleChoiceHoverStyles()}
          selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
        />
      </div>
    </div>
  );
};

export default SingleChoiceOne;
